import { keepDefined } from '@pbk/utils';
export const getScopesFromUmaPermissions = (permissions) => {
    const flatScopes = permissions.flatMap((resource) => resource.scopes);
    return keepDefined(flatScopes);
};
